export default config;

function config($locationProvider, $httpProvider, uiGmapGoogleMapApiProvider, $logProvider, $provide) {
    'ngInject';

    //$qProvider.errorOnUnhandledRejections(false); TODO angular 1.6 ??

    $logProvider.debugEnabled(true);

    $locationProvider.hashPrefix('');

    uiGmapGoogleMapApiProvider.configure({
        v: '3.20',
        libraries: 'weather,geometry,visualization'
    });

    $httpProvider.defaults.headers.common = {
        'App-Id': 'f6b16c23',
        'App-Key': 'f0bc4f65f4fbfe7b4b3b7264b655f5eb'
    };

    $provide.decorator('$sniffer', ($delegate) => {

        const regexp = /Safari\/([\d.]+)/;
        const result = regexp.exec(navigator.userAgent);
        const webkit_version = result ? parseFloat(result[1]) : null;

        _.extend($delegate, {webkit: webkit_version});

        return $delegate;
    });

    /*
        TODO: FIND A BETTER WAY!
        We're using this interceptor to
        ensure company children are suppressed from API
        response when using the companySearch UI
    */
    $httpProvider.interceptors.push('companySearchInterceptor');

}

window.getURIparam = function (name) {  //TODO remove
    name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    const regexS = '[\\?&]' + name + '=([^&#]*)';
    const regex = new RegExp(regexS);
    const results = regex.exec(window.location.href);
    if (results == null)
        return '';
    else
        return results[1];
};


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/main.config.js